<template>

    <div class="relative text-gray-400 ">
      <div class="relative overflow-hidden">

        <div class="relative pt-6 pb-16 sm:pb-24">
            <!-- Header section -->


            <div class="mx-auto py-12 px-4 max-w-7xl sm:px-6 lg:px-8 lg:py-24">
                <div class="space-y-12">
                    <!-- md:max-w-xl lg:max-w-3xl xl:max-w-none -->
                <div class="text-center space-y-5 sm:space-y-4">
                    <h2 class="text-white uppercase text-3xl font-extrabold tracking-tight sm:text-4xl sm:mt-2">Industry Solutions</h2>
                    <div class="relative mt-1">
                        <div class="absolute inset-0 flex items-center" aria-hidden="true">
                            <div class="w-full border-t border-gray-700"></div>
                        </div>
                        <div @click="showContactModal"  class="relative flex justify-center cursor-pointer">
                            <span class="px-2 bg-gradient-to-r from-orange-500 to-orange-800 text-sm rounded-md text-white font-bold"> Contact Us </span>
                        </div>
                    </div>

                    <p class="font-sans mt-4 max-w-md mx-auto text-base text-gray-300 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl">
                      The following software provide a baseline to customize your Application.<br> Add features to our scalable, modular architecture that grows with your business!
                      <br>
                      For a full demonstration and more information please contact us.
                    </p>


                 
                </div>

                <div class="grid gap-y-8 grid-cols-1 sm:grid-cols-2 sm:gap-x-6 sm:gap-y-12 sm:space-y-0 lg:grid-cols-3">
                  
                    <div @click="redirect('https://chamber.vqventure.com/', 'Chamber of Commerce', chamber, 'https://vqv-assets.s3.amazonaws.com/chamber/subs.png')" 
                        class="space-y-4 rounded-md cursor-pointer p-4 bg-black bg-opacity-25 zoomIn">
                        <div class="aspect-w-3 aspect-h-2">
                            <img class="object-cover shadow-2xl rounded-lg" src="https://homemanagerfortesting.s3.amazonaws.com/chamber.png" alt="">
                        </div>

                        <div class="space-y-2 text-center">
                            <div class="text-lg leading-6 font-medium space-y-1 text-gray-50">
                                <h3>Chambers of Commerce</h3>
                            </div>

                        </div>
                    </div>
                

                    <div @click="redirect('https://scheduler-demo.vqventure.com/', 'Business Scheduling', construction, 'https://vqv-assets.s3.amazonaws.com/scheduler/welcome.png')"  
                        class="space-y-4 rounded-md cursor-pointer p-4 bg-black bg-opacity-25 zoomIn">
                        <div class="aspect-w-3 aspect-h-2">
                        <img class="shadow object-cover shadow-2xl rounded-lg" src="https://homemanagerfortesting.s3.amazonaws.com/360demo.jpg" alt="">
                        </div>

                        <div class="space-y-2 text-center">
                            <div class="text-lg leading-6 font-medium space-y-1 text-gray-50">
                                <h3>Construction Businesses</h3>
                            </div>

                        </div>
                    </div>
               

                    <div @click="redirect('https://glenn-demo.vqventure.com/', 'Digital Document Management', glenn, 'https://vqv-assets.s3.amazonaws.com/glenn/welcome.png')"  
                        class="space-y-4 rounded-md cursor-pointer p-4 bg-black bg-opacity-25 zoomIn">
                        <div class="aspect-w-3 aspect-h-">
                        <img class="object-cover shadow-2xl rounded-lg" src="https://homemanagerfortesting.s3.amazonaws.com/glen.jpg" alt="">
                        </div>

                        <div class="space-y-2 text-center">
                            <div class="text-lg leading-6 font-medium space-y-1 text-gray-50">
                                <h3>Digital Document Management</h3>
                            </div>

                        </div>
                    </div>


  
                    <div @click="redirect('https://spring-lake-demo.vqventure.com/', 'Goverment Software', spring, 'https://vqv-assets.s3.amazonaws.com/town/welcome.png')" 
                        class="space-y-4 rounded-md cursor-pointer p-4 bg-black bg-opacity-25 zoomIn">
                        <div class="aspect-w-3 aspect-h-2 ">
                        <img class="object-cover shadow-2xl rounded-lg" src="https://homemanagerfortesting.s3.amazonaws.com/twon.jpg" alt="">
                        </div>

                        <div class="space-y-2 text-center">
                            <div class="text-lg leading-6 font-medium space-y-1 text-gray-50">
                                <h3>Government Agencies</h3>
                            </div>

                        </div>
                    </div>
           

        
                    <div @click="redirect('https://scheduler-demo.vqventure.com/', 'Waste Disposal Services', trash, 'https://vqv-assets.s3.amazonaws.com/trash/welcome.png')" 
                        class="space-y-4 rounded-md cursor-pointer p-4 bg-black bg-opacity-25 zoomIn">
                        <div class="aspect-w-3 aspect-h-2 ">
                            <img class="object-cover shadow-2xl rounded-lg" src="https://homemanagerfortesting.s3.amazonaws.com/justin.jpg" alt="">
                        </div>

                        <div class="space-y-2 text-center">
                            <div class="text-lg leading-6 font-medium space-y-1 text-gray-50">
                                <h3>Businesses with Recurring Services Rendered</h3>
                            </div>

                        </div>
                    </div>
         
                </div>
                </div>
            </div>


        </div>


      </div>



        <div v-if="delayItem" :class="{'delay': delayItem }" :style="delayItem ? 'display:flex' : 'display:none'" class="relative bg-white">
            <contact :requestedUrl="requestedProyectUrl" :proyect="proyect" v-on:event="delayItem = false"></contact>
        </div>
        <!-- modal -->
      <v-dialog v-model="displayModal" v-if="displayModal" width="900">

                <div class="bg-gray-900 bg-opacity-25 py-4 rounded-md px-4 ">
                    <getStarted></getStarted>
                </div>

      </v-dialog>



    </div>


        <!-- <div class="container">
            <card data-image="https://homemanagerfortesting.s3.amazonaws.com/chamber.png">
                <h1 slot="header">Canyons</h1>
                <p slot="content">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</p>
            </card>
            <card data-image="https://homemanagerfortesting.s3.amazonaws.com/360demo.jpg">
                <h1 slot="header">Beaches</h1>
                <p slot="content">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</p>
            </card>
            <card data-image="https://homemanagerfortesting.s3.amazonaws.com/glen.jpg">
                <h1 slot="header">Trees</h1>
                <p slot="content">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</p>
            </card>
            <card data-image="https://homemanagerfortesting.s3.amazonaws.com/twon.jpg">
                <h1 slot="header">Lakes</h1>
                <p slot="content">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</p>
            </card>
        </div> -->

</template>

<script>
// import card from './Card.vue'
export default {
//   components: {card},
  data() {
    return {
      delayItem: false,
      proyect: '',
      requestedProyectUrl: '',
      displayModal: false,

      construction: `After running a construction business for multiple years our founder, Jesse Burger, created this solution to meet the needs of his business. 
                    With this solution scheduling becomes a breeze, staying on top of upcoming jobs and managing projects is simplified, creating estimates and sending invoices for payment all through one system. 
                    By putting all the business needs into a single platform you can save costs and most importantly the headache of logging into multiple systems to do the most basic of business needs. 

                    We are happy to provide a full demonstration of the entire system and show you how the software can be customized to your specific needs`,

      chamber: `VQV’s solution for Chambers of Commerce came from our Founder working on the Board for multiple Chambers of Commerce. 
                VQV’s solution incorporates payment processing, advertising, job placement, public and private surveys, and much more! When you are ready to grow your area’s Chamber of Commerce, choose VQV to provide the technological resources to get you there!

	            We are happy to provide a full demonstration of the entire system and show you how the software can be customized to your specific needs`,
                
      glenn: `This software was designed to provide our CPA the ability to work on client documents remotely, securely share documents and files with clients and simplify the client business interaction. 

              We are happy to provide a full demonstration of the entire system and show you how the software can be customized to your specific needs`,

     spring: `The Town of Spring Lake web application is an entire platform designed to do everything from automatically notifying the town of weather events, to digitizing official forms and allowing for online submission of documents. 
              The robust capabilities in this platform allow for small to medium sized government agencies to easily handle their business within a single platform. Additionally, this software is infinitely customizable for each client. 
              Need to integrate a payment processor? Not problem! Adding digital signatures to documents for security purposes? We have you covered. No matter what your needs, our software either already handles the problems or can be customized to your needs. 

	          We are happy to provide a full demonstration of the entire system and show you how the software can be customized to your specific needs`,

    trash: `So many businesses utilize recurring payments in their business model. VQV’s solution to this allows businesses to easily signup new clients for services, be it repeating or single charges, manage all clients and scheduling. 
            If you have a business that charges clients on a repetitive basis and want to automate the process, this is the software for you!

	        We are happy to provide a full demonstration of the entire system and show you how the software can be customized to your specific needs`

   
    };
  },

  computed: {
    sessionItem(){
      return sessionStorage.getItem('modal');
    }

    },


  methods: {
    singleDemo(value){
        this.$router.push({ name: "SingleDemo", params: { id: value } })
    },
    redirect(url, value, description, image) {


        this.$router.push({ name: "SingleProject", params: {id: value, desc: description, image: image} });
        // this.delayItem = true
        this.proyect = value
        this.requestedProyectUrl = url

    },
    showContactModal(){
        this.displayModal = true;
    }

  }
};
</script>

<style scoped>

.delay {

  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;

  /* this is what centers your element in the fixed wrapper*/
  display: flex;
  flex-flow: column nowrap;
  justify-content: center; /* aligns on vertical for column */
  align-items: center; /* aligns on horizontal for column */


  z-index: 50;
  animation-name: fadeIn;
  -webkit-animation-name: fadeIn;
  animation: 1s ease 0s normal forwards 1 fadeIn;

}

@keyframes fadeIn{
     0% { opacity:0; }
    66% { opacity:0; }
    100% { opacity:1; }
}

/* .zoomIn  {
	-webkit-transform: scale(1);
	transform: scale(1);
	-webkit-transition: .3s ease-in-out;
	transition: .3s ease-in-out;
}

.zoomIn:hover  {
	-webkit-transform: scale(1.1);
	transform: scale(1.1);
} */



</style>
